import {Component, OnInit} from "@angular/core";
import {IOption} from "ng-select";
import {BsModalRef} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";

@Component({
  selector: "app-report-ncr-print-preview",
  templateUrl: "./report-ncr-print-preview.component.html",
  styleUrls: ["./report-ncr-print-preview.component.scss"],
  providers: [RilrService, HelperService],
})
export class ReportNcrPrintPreviewComponent implements OnInit {

  public masterData: any = {};
  public incidentColspan: number = 0;
  public reportSystemID: number;
  public documentSystemID: number;
  public documentTypeLabel: string = "incident report";
  public incidentTypeArr= [];
  public incidentTypeArrAll= [];
  public ncrCategoryBoxArr: Array<IOption> = [];
  public allCountryArr: Array<IOption> = [];
  public supplierArr: Array<IOption> = [];
  public companySystemID = this.helperService.getSelectedCompanyId();
  public incidentCategoryArr: any[];
  public incidentSubCategoryArr: any[];
  public incidentSubCategoryDynamicArr: any[];
  public correctiveActionsTbl: any = [];
  public immediateCauses: any = [];
  public rootCauses: any = [];
  public typeOfEvent: any = [];
  public auditorsInformationTbl: any = [];

  yesNoArr: any = [
    {value: 0, label: 'No'},
    {value: 1, label: 'Yes'}
  ];

  DispositionProductArr: any = [
    {value: 1, label: 'Return to supplier (RTS)'},
    {value: 2, label: 'Rework'},
    {value: 3, label: 'Scrap'},
    {value: 4, label: 'USE AS IS (UAI)'},
    {value: 5, label: 'Repair'},
  ];

  DispositionServiceArr: any = [
    {value: 1, label: 'Request supplier car'},
    {value: 2, label: 'Provide corrected service'}
  ];

  ncrCategoryTypeArr: any = [
    {value: 1, label: 'Product'},
    {value: 2, label: 'Service'}
  ];

  constructor(public bsModalRef: BsModalRef,
              private helperService: HelperService,
              private spinner: NgxSpinnerService,
              private rilrService: RilrService) {
  }

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.reportPrintPreview();
    }, 0);

  }

  public reportPrintPreview() {
    const that = this;
    that.rilrService
      .reportNCRPrintPreviewData()
      .get({
        companySystemID: that.companySystemID,
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID
      })
      .subscribe(data => {
        const resp = data.data.data;
        that.incidentTypeArr = that.helperService.incidentsIdChangeToInt(resp.incidents);
        that.incidentTypeArrAll = that.helperService.incidentsIdChangeToInt(resp.incidentsAll);
        that.incidentCategoryArr = resp.incidentCategory;
        that.incidentSubCategoryArr = resp.IncidentSubCategory;
        that.masterData = resp.reportData;
        that.incidentSubCategoryDynamicArr = resp.incidentDynamicSubCategory;
        that.correctiveActionsTbl = resp.actions;
        that.immediateCauses = resp.immediateCauses;
        that.rootCauses = resp.rootCauses;
        that.typeOfEvent = resp.type_of_event;
        that.auditorsInformationTbl = resp.auditorDetails;
        that.documentTypeLabel = resp.document ? resp.document.documentDescription : '';
        that.masterData.ncrValidity = that.helperService.setSelectedValue(that.masterData.ncrValidity);
        that.masterData.similarNonConformity = that.helperService.setSelectedValue(that.masterData.similarNonConformity);
        that.masterData.reviewRequiredFullMRB = that.helperService.setSelectedValue(that.masterData.reviewRequiredFullMRB);
        that.masterData.dispositionProduct = that.helperService.setSelectedValue(that.masterData.dispositionProduct);
        that.masterData.dispositionService = that.helperService.setSelectedValue(that.masterData.dispositionService);
        that.masterData.ncrType = that.helperService.setSelectedValue(that.masterData.ncrType);
        that.masterData.ncrCategory = that.helperService.setSelectedValue(that.masterData.ncrCategory);
        that.masterData.supplierCountryID = that.helperService.setSelectedValue(that.masterData.supplierCountryID);
        that.processSupplierEdit(that.masterData.supplierCountryID);

        setTimeout(() => {
          if(!that.incidentTypeArr.some((incident) => incident.id == that.masterData.reportNewSystemID)){
            let incidentIndex = that.incidentTypeArrAll.findIndex(i => i.id == that.masterData.reportNewSystemID)
            if(incidentIndex > -1){
              that.incidentTypeArr.push(that.incidentTypeArrAll[incidentIndex])
            }
          }
          that.incidentColspan = that.incidentTypeArr.length;
        }, 0);
       
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
      });
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  public print_pdf_preview() {
    // const urlGeneratingPdf = 'api/v1/printReportPDF?id=' + this.reportSystemID + '&documentSystemID=' + this.documentSystemID + '&companySystemID=' + this.companySystemID;
    //  window.open(urlGeneratingPdf, '_blank');
    const that = this;
    that.rilrService
      .printReportPDF()
      .get({
        id: that.reportSystemID,
        documentSystemID: that.documentSystemID,
        companySystemID: that.companySystemID,
      })
      .subscribe(resp => {
        const data = resp.data.data;
        window.open(data.pdf_path, "_blank");
      }, (error) => {
        if (error.status == 500) {
          //that.tosterMessageService.showError("Error", error.data.message);
        }
      });
  }

  processSupplierEdit(countryID) {
    const that = this;
    that.supplierArr = [];
    that.rilrService
      .getSupplierByCountry()
      .get({countryCode: countryID, companySystemID: +(that.helperService.getSelectedCompanyId())})
      .subscribe((data) => {
        var resp = data.data.data;
        that.supplierArr = that.helperService.setSelect2DropDownOptions(resp, 'customerID', 'customerName');
        setTimeout(() => {
          that.masterData.supplierSystemID = that.helperService.setSelectedValue(that.masterData.supplierSystemID);
          that.spinner.hide();
        }, 0);
      }, () => {
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/report-ncr-print-preview/report-ncr-print-preview.component.ts